
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * IdempotentRequestState enum
 */
class IdempotentRequestState {
  /**
   * Initialize enum with a given value
   * @param {IdempotentRequestState|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof IdempotentRequestState) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!IdempotentRequestState}
   * @param {!IdempotentRequestState} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof IdempotentRequestState)) {
      throw new TypeError('Instance of IdempotentRequestState is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!IdempotentRequestState}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!IdempotentRequestState}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === IdempotentRequestState.SUCCESS.value) {
      return 'SUCCESS'
    }
    if (this.value === IdempotentRequestState.PENDING.value) {
      return 'PENDING'
    }
    if (this.value === IdempotentRequestState.FAILED.value) {
      return 'FAILED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!IdempotentRequestState}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!IdempotentRequestState}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!IdempotentRequestState} Created enum
   */
  static fromObject (other) {
    return new IdempotentRequestState(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
IdempotentRequestState.SUCCESS = new IdempotentRequestState(0 + 0)
// noinspection PointlessArithmeticExpressionJS
IdempotentRequestState.PENDING = new IdempotentRequestState(0 + 1)
// noinspection PointlessArithmeticExpressionJS
IdempotentRequestState.FAILED = new IdempotentRequestState(0 + 2)

export { IdempotentRequestState };

/**
 * Fast Binary Encoding IdempotentRequestState field model
 */
class FieldModelIdempotentRequestState extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelIdempotentRequestState}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelIdempotentRequestState}
   * @param {IdempotentRequestState=} defaults Default value, defaults is new IdempotentRequestState()
   * @returns {!IdempotentRequestState} Result value
   */
  get (defaults = new IdempotentRequestState()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new IdempotentRequestState(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelIdempotentRequestState}
   * @param {!IdempotentRequestState} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelIdempotentRequestState };
